export const MIN_SWINGS = 25

export const MAX_SWING_TIMING_SELECTIONS = 5
